"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizBadRequestError = void 0;
const client_library_1 = require("@seneca/client-library");
class QuizBadRequestError extends client_library_1.ExtendableError {
}
exports.QuizBadRequestError = QuizBadRequestError;
//# sourceMappingURL=QuizBadRequestError.js.map